import React from "react";
import Reveal from "./Reveal";
import { ChannelLogo } from "./Logos";
import { OFFICE_IMAGE, CHANNELS, REPLY_FACTS } from "../mock";

export default function ReplyDesk() {
  return (
    <section id="reply" style={{ padding: "64px 0" }}>
      <div className="container-x">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <div style={{ position: "relative", borderRadius: 4, overflow: "hidden", border: "1px solid var(--line)" }}>
              <img
                src={OFFICE_IMAGE}
                alt="Open-plan office with desks, monitors and hanging lights"
                style={{ display: "block", width: "100%", height: 420, objectFit: "cover", filter: "saturate(0.92) contrast(1.02)" }}
              />
              <div style={{ position: "absolute", inset: 0, background: "linear-gradient(180deg, rgba(25,23,32,0) 50%, rgba(25,23,32,0.42))" }} />
              <div style={{ position: "absolute", left: 20, bottom: 18, color: "#f5f2ea" }}>
                <div className="eyebrow" style={{ color: "#f5f2eab0" }}>The reply desk</div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div>
              <div className="section-label">The reply desk</div>
              <h2 className="h-section" style={{ marginTop: 18 }}>
                Written in India.{" "}
                <span className="serif" style={{ fontSize: "1.05em" }}>Answered in Rotterdam.</span>
              </h2>

              <div style={{ marginTop: 28 }}>
                <div className="eyebrow" style={{ marginBottom: 14 }}>Channels and data</div>
                <div style={{ border: "1px solid var(--line)", borderRadius: 6, overflow: "hidden", background: "var(--card)" }}>
                  {CHANNELS.map((c, i) => (
                    <div
                      key={c.name}
                      className="flex items-center gap-3"
                      style={{
                        padding: "13px 16px",
                        borderBottom: i < CHANNELS.length - 1 ? "1px solid var(--line)" : "none",
                        transition: "background 0.2s ease",
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.background = "var(--paper-2)")}
                      onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                    >
                      <ChannelLogo name={c.name} />
                      <span style={{ fontSize: 14.5, fontWeight: 500 }}>{c.name}</span>
                      <span className="mono" style={{ marginLeft: "auto", fontSize: 11, color: "var(--ink-faint)", letterSpacing: "0.04em" }}>
                        {i < 2 ? "sending" : i === 2 ? "touches" : "data"}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              <div style={{ marginTop: 30, borderTop: "1px solid var(--line)" }}>
                {REPLY_FACTS.map((f, i) => (
                  <div key={i} className="flex items-baseline justify-between" style={{ padding: "14px 0", borderBottom: "1px solid var(--line)" }}>
                    <span className="eyebrow">{f.k}</span>
                    <span style={{ fontSize: 15, fontWeight: 500, textAlign: "right" }}>{f.v}</span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
